import { formatMoney } from 'accounting'

import {
  Line, ListItem, LoadingModule, SidebarNoticeBox, Text,
} from '@domain-group/suit-theme'

import ProductOptionsSelector from '@components/ProductOptionsSelector'

// @ts-expect-error TS2724
import { AgencyMarketingOrderPayload } from '@modals/CreateAgencyMarketingOrderModal/hooks/useAgencyMarketingOrder'

interface ProductSelectionProps {
  agencyMarketingOrderPayload: AgencyMarketingOrderPayload,
}

const ProductSelection = (props: ProductSelectionProps) => {
  const { agencyMarketingOrderPayload } = props

  const {
    callbacks: {
      selectProviderPriceListItemId,
      selectProviderPriceListItemOptionValue,
    },
    currentPriceList,
    currentPrice: { total },
    loadingPriceLists,
    filteredPriceListItems,
    selectedProduct,
    selectedProviderPriceListItemId,
    selectedProviderPriceListItemOptions,
  } = agencyMarketingOrderPayload

  return (
    <>
      {loadingPriceLists && (
        <LoadingModule loading={loadingPriceLists} />
      )}

      {!loadingPriceLists && !currentPriceList.id && (
        <SidebarNoticeBox boxProps={{ marginTop: 'large' }}>
          <SidebarNoticeBox.Title>
            No price list available
          </SidebarNoticeBox.Title>

          <SidebarNoticeBox.Paragraph>
            The selected provider does not have a price list assigned to your agency for the selected service. Please
            contact Realhub support for assistance.
          </SidebarNoticeBox.Paragraph>
        </SidebarNoticeBox>
      )}

      {!!selectedProduct.id && !!currentPriceList.id && (
        <ProductOptionsSelector
          callbacks={{
            selectProviderPriceListItemId,
            selectProviderPriceListItemOptionValue,
          }}
          providerPriceListItems={filteredPriceListItems}
          quantityFormFieldBoxProps={{ marginTop: 'large' }}
          selectedProviderPriceListItemId={selectedProviderPriceListItemId}
          selectedProviderPriceListItemOptions={selectedProviderPriceListItemOptions}
        />
      )}

      <Line />

      <ListItem
        boxProps={{ alignItems: 'center', justifyContent: 'space-between', marginTop: 'medium' }}
        disableHover
      >
        <Text fontSize="medium" color="bodyFontLightColor">Amount</Text>

        <Text fontSize="medium">{formatMoney(total)}</Text>
      </ListItem>
    </>
  )
}

export default ProductSelection
